import { Mapper } from '../services/Mapper'

export default {
  data () {
    return {
      pinMarkers: false,
      pinMarkersText: 'Pin Map Markers',
      showScale: false,
      showScaleText: 'Add distance scale',
      style: { name: 'Streets', version: 'streets-v11' },
      styles: [
        { name: 'Streets', version: 'streets-v11' },
        { name: 'Light', version: 'light-v10' },
        { name: 'Dark', version: 'dark-v10' },
        { name: 'Outdoors', version: 'outdoors-v11' },
        { name: 'Satellite', version: 'satellite-v9' }
      ]
    }
  },

  methods: {
    setHome () {
      const center = this.mapper.getCenter()
      const zoom = this.mapper.getZoom()

      this.$storage.set('home', { center, zoom })
      this.snackbarMessage('Home map saved')
    },

    togglePinMarkers () {
      this.pinMarkers = !this.pinMarkers
      this.$storage.set('pinMarkers', this.pinMarkers)
      this.changePinMarkers()
    },

    toggleScaleControl () {
      this.showScale = !this.showScale
      this.$storage.set('showScale', this.showScale)
      this.changeScaleControl()
    },

    setStyle (style) {
      this.style = style
      this.mapper.setStyle(style.version)
    },

    changePinMarkers (showSnackBar = true) {
      if (this.pinMarkers) {
        this.pinMarkersText = 'Unpin map markers'
      } else {
        this.mapper.removeAllMarkers()
        this.pinMarkersText = 'Pin map markers'
      }

      if (showSnackBar) {
        const message = this.pinMarkers
          ? 'Map markers are pinned'
          : 'Map markers are unpinned'

        this.snackbarMessage(message)
      }
    },

    changeScaleControl (showSnackBar = true) {
      if (this.showScale) {
        this.mapper.addScaleControl()
        this.showScaleText = 'Remove distance scale'
      } else {
        this.mapper.removeScaleControl()
        this.showScaleText = 'Add distance scale'
      }

      if (showSnackBar) {
        const message = this.showScale
          ? 'Distance scale added'
          : 'Distance scale removed'

        this.snackbarMessage(message)
      }
    },

    snackbarMessage (message) {
      this.$emit('update:snackbar-message', message)
      this.$emit('update:show-snackbar', true)
    }
  },

  created () {
    this.mapper = Mapper.instance

    this.pinMarkers = this.$storage.get('pinMarkers', false)
    this.changePinMarkers(false)

    this.showScale = this.$storage.get('showScale', false)
    this.changeScaleControl(false)
  }
}
